var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pl-12 pr-12", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { column: "", wrap: "" } },
        [
          _c(
            "v-row",
            [
              _c("v-col", [
                _c(
                  "p",
                  {
                    staticClass: "font-weight-black pl-3",
                    staticStyle: { "font-size": "32px" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("title.agency.home")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c("v-col", { staticClass: "pa-0 ma-0" }, [
                _c("p", { staticClass: "pl-5" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("description.agencyTop.topExplanation")) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "v-card",
                    { attrs: { outlined: "", height: "auto" } },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  staticStyle: { "max-width": "315px" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "font-weight-black",
                                      staticStyle: { "font-size": "20px" },
                                      attrs: {
                                        slot: "activator",
                                        align: "center",
                                        width: "100%",
                                        height: "96px",
                                        "max-width": "300px",
                                        color: "next",
                                        dark: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onClickSearchContractButton()
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("label.searchContract")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("v-col", { staticClass: "py-0" }, [
                                _c("p", { staticClass: "pl-3 mb-0" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "description.agencyTop.searchExplanation"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "pt-y mb-0", staticStyle: { "max-height": "75px" } },
            [
              _c("v-col", { staticClass: "mb-0 pb-0" }, [
                _c(
                  "p",
                  {
                    staticClass: "font-weight-black px-4 pt-4 mb-0",
                    staticStyle: { "font-size": "24px" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("label.contractList")) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _c(
                "v-col",
                { staticClass: "mb-0 pb-0" },
                [
                  _c(
                    "v-layout",
                    { staticClass: "float-right" },
                    [
                      _c("v-switch", {
                        attrs: {
                          color: "next",
                          "input-value": false,
                          label: _vm.$t("button.showWithdrawalContract"),
                          "hide-details": true
                        },
                        on: { change: _vm.onChangeWithdrawContractButton }
                      }),
                      _c(
                        "v-chip",
                        {
                          staticClass: "font-weight-black ml-4",
                          staticStyle: { "margin-top": "15px" },
                          attrs: {
                            ripple: "",
                            disabled: !_vm.isClearSearchConditionBtnEnable
                          },
                          on: {
                            click: function($event) {
                              return _vm.onClickClearButton()
                            }
                          }
                        },
                        [
                          _vm._v(_vm._s(_vm.$t("button.conditionClear"))),
                          _c("v-icon", [_vm._v("mdi-delete")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "ma-0 pa-0", staticStyle: { width: "100%" } },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0" },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      "calculate-widths": "",
                      headers: _vm.headers,
                      items: _vm.records,
                      options: _vm.options,
                      "server-items-length": _vm.total,
                      loading: _vm.isLoading,
                      "loading-text": _vm.$t("description.contractReading"),
                      "no-data-text": _vm.$t("error.contractListNotFound"),
                      "footer-props": {
                        itemsPerPageText: "1ページあたりの行数",
                        itemsPerPageOptions: _vm.itemsPerPageOptions
                      }
                    },
                    on: {
                      "update:options": function($event) {
                        _vm.options = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.detail",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "router-link-transparent",
                                staticStyle: { "text-decoration": "none" },
                                attrs: {
                                  to: {
                                    name: "ContractDetail",
                                    params: { contractId: item.id }
                                  },
                                  target: _vm.isDetailButtonEnabled(item)
                                    ? "_blank"
                                    : "",
                                  event: _vm.isDetailButtonEnabled(item)
                                    ? "click"
                                    : ""
                                }
                              },
                              [
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass:
                                        "font-weight-black float-center",
                                      attrs: {
                                        color: "next",
                                        dark: _vm.isDetailButtonEnabled(item),
                                        disabled: !_vm.isDetailButtonEnabled(
                                          item
                                        ),
                                        ripple: "",
                                        link: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "header.contractListTable.detail"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ],
                              2
                            )
                          ]
                        }
                      },
                      {
                        key: "item.status",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            item.lockoutStatus === _vm.lockedStatus
                              ? _c(
                                  "strong",
                                  {
                                    class: _vm.checkLockoutStyle(
                                      item.lockoutStatus
                                    )
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.status) +
                                        "(" +
                                        _vm._s(_vm.$t("label.lockout")) +
                                        ")\n            "
                                    )
                                  ]
                                )
                              : [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.status) +
                                      "\n            "
                                  )
                                ]
                          ]
                        }
                      },
                      {
                        key: "item.startStatus",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            item.isStrong
                              ? _c(
                                  "strong",
                                  { class: item.isAlert ? _vm.alertStyle : "" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.startStatus) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.startStatus) +
                                      "\n            "
                                  )
                                ]
                          ]
                        }
                      },
                      {
                        key: "item.note",
                        fn: function(ref) {
                          var item = ref.item
                          return _vm._l(
                            _vm.splitMessageLine(item.note),
                            function(message, index) {
                              return _c(
                                "p",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: { "font-size": "14px" },
                                  attrs: { align: "left" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(message) +
                                      "\n            "
                                  )
                                ]
                              )
                            }
                          )
                        }
                      }
                    ])
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-black float-right",
                              attrs: { color: "next", dark: "" },
                              on: {
                                click: function($event) {
                                  return _vm.onClickCsvDownloadButton()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.downloadCsv")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("ContractListSearchDialog", {
            ref: "contractListSearchDialog",
            on: {
              onSuccess: _vm.onSuccessContractListSearch,
              onClear: _vm.onClearSearchCondition
            }
          }),
          _c("CompletedDialog", { ref: "completedDialog" }),
          _c("ErrorDialog", { ref: "errorDialog" }),
          _c("FormsDialog", {
            attrs: {
              showDialog: _vm.showEditNoteDialog,
              title: _vm.$t("header.contractListTable.note"),
              text: null,
              subText: null,
              negativeButtonTitle: _vm.$t("button.cancel"),
              positiveButtonTitle: _vm.$t("button.update"),
              onClickNegativeButton: _vm.cancelEditNote,
              onClickPositiveButton: _vm.updateNote,
              targets: _vm.editNoteTargets
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }